import { render, staticRenderFns } from "./SobeceReport.vue?vue&type=template&id=7a154482&"
import script from "./SobeceReport.vue?vue&type=script&lang=js&"
export * from "./SobeceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports